var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.16663 11.9054C2.62382 12.586 1.66663 13.5344 1.66663 14.5834C1.66663 16.6545 5.39759 18.3334 9.99996 18.3334C14.6023 18.3334 18.3333 16.6545 18.3333 14.5834C18.3333 13.5344 17.3761 12.586 15.8333 11.9054M15 6.66675C15 10.0532 11.25 11.6667 9.99996 14.1667C8.74996 11.6667 4.99996 10.0532 4.99996 6.66675C4.99996 3.90532 7.23854 1.66675 9.99996 1.66675C12.7614 1.66675 15 3.90532 15 6.66675ZM10.8333 6.66675C10.8333 7.12699 10.4602 7.50008 9.99996 7.50008C9.53972 7.50008 9.16663 7.12699 9.16663 6.66675C9.16663 6.20651 9.53972 5.83341 9.99996 5.83341C10.4602 5.83341 10.8333 6.20651 10.8333 6.66675Z",
    stroke: "#98A2B3",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.8b6d360d102462e00940c4acb7e85ec3.svg";
export { ForwardRef as ReactComponent };